'use strict';

module.exports = require('./DialogWrap');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-dialog/lib/index.js
 ** module id = 345
 ** module chunks = 0
 **/